import { axios_institute_private } from "../../../../api/setup.intersepter";

export const getRegistrationQuery = (body: string) => {
  return axios_institute_private({
    method: "GET",
    url: `/institutions?instituteId=${body}`,
  });
};
